import { render, staticRenderFns } from "./MasterclassRow.vue?vue&type=template&id=097acde8&scoped=true&"
import script from "./MasterclassRow.vue?vue&type=script&lang=js&"
export * from "./MasterclassRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097acde8",
  null
  
)

export default component.exports